module.exports = __webpack_public_path__ + "img/EIO102&103.2b27fffd.png";